import { IScopingItemGroupMapping } from '../models/iscoping-item-group-mapping';
import { IDependentItem } from './idependent-item';
import { IItemRecordChangedEvent } from './iitem-record-changed-event';

export class ScopingItemGroupMapping implements IScopingItemGroupMapping {

  public ScopingItemId: number;
  public ScopingItemNumber: number;
  public ScopingItemName: string;
  public MappedDependentItems: IDependentItem[];
  public RemovedDependentItemIds: number[];

  public Update(source: ScopingItemGroupMapping): void {
    this.ScopingItemId = source.ScopingItemId;
    this.ScopingItemNumber = source.ScopingItemNumber;
    this.ScopingItemName = source.ScopingItemName;
  }

  public static Create(source: IScopingItemGroupMapping, changeEvent: IItemRecordChangedEvent): ScopingItemGroupMapping {
    let existingGroup = null;

    if (changeEvent != null && changeEvent.ItemGroupMappings != null && changeEvent.ItemGroupMappings.length > 0) {
      existingGroup = changeEvent.ItemGroupMappings.find(f => f.ScopingItemId === source.ScopingItemId);
    }

    let result: ScopingItemGroupMapping;

    if (existingGroup != null) {
      result = existingGroup;
    } else {
      result = new ScopingItemGroupMapping();

      Object.assign(result, source);

      if (!result.MappedDependentItems) {
        result.MappedDependentItems = [];
      }
    }

    return result;
  }

  AddDependentItem(dependentItem: IDependentItem) {
    if (this.MappedDependentItems.find(f => f.DependentItemId === dependentItem.DependentItemId) == null) {
      this.MappedDependentItems.push(dependentItem);
    }

    if (this.RemovedDependentItemIds && this.RemovedDependentItemIds.length) {
      let removedIndex = this.RemovedDependentItemIds.indexOf(dependentItem.DependentItemId);
      if (removedIndex >= 0) {
        this.RemovedDependentItemIds.splice(removedIndex, 1);
      }
    }
  }

  UpdateDependentItem(dependentItem: IDependentItem) {
    if (this.MappedDependentItems.find(f => f.DependentItemId === dependentItem.DependentItemId) != null) {
      let dependentItemToUpdate = this.MappedDependentItems.find(f => f.DependentItemId === dependentItem.DependentItemId);
      dependentItemToUpdate = dependentItem;
    }
  }

  RemoveDependentItem(dependentItem: IDependentItem) {
    let dependentItemIndex = this.MappedDependentItems.findIndex(d => d.DependentItemId === dependentItem.DependentItemId);
    if (dependentItemIndex !== -1) {
      this.MappedDependentItems.splice(dependentItemIndex, 1);

      if (this.RemovedDependentItemIds == null) {
        this.RemovedDependentItemIds = [];
      }
      this.RemovedDependentItemIds.push(dependentItem.DependentItemId);
    }
  }
}